import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseLinebreakFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.5H18C19.933 2.5 21.5 4.067 21.5 6V18C21.5 19.933 19.933 21.5 18 21.5H6C4.067 21.5 2.5 19.933 2.5 18V6C2.5 4.067 4.067 2.5 6 2.5ZM16.75 9C16.75 8.58579 16.4142 8.25 16 8.25C15.5858 8.25 15.25 8.58579 15.25 9V11C15.25 11.6904 14.6904 12.25 14 12.25H8.81066L10.5303 10.5303C10.8232 10.2374 10.8232 9.76256 10.5303 9.46967C10.2374 9.17678 9.76256 9.17678 9.46967 9.46967L6.46967 12.4697C6.17678 12.7626 6.17678 13.2374 6.46967 13.5303L9.46967 16.5303C9.76256 16.8232 10.2374 16.8232 10.5303 16.5303C10.8232 16.2374 10.8232 15.7626 10.5303 15.4697L8.81066 13.75H14C15.5188 13.75 16.75 12.5188 16.75 11V9Z"
        fill={color}
      />
    </svg>
  );
};
